export const API_URL = 'https://api.cashout.kassa24.kz';

export default {
  API_URL,
};
